import api from './api';

export const wishlistsService = {
    // Get all user wishlists
    async getWishlists(params = {}) {
        try {
            const response = await api.get('/wishlists/', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching wishlists:', error);
            throw error;
        }
    },

    // Get single wishlist details
    async getWishlist(id) {
        try {
            const response = await api.get(`/wishlists/${id}/`);
            return response.data;
        } catch (error) {
            console.error('Error fetching wishlist:', error);
            throw error;
        }
    },

    // Create new wishlist
    async createWishlist(wishlistData) {
        try {
            const response = await api.post('/wishlists/', wishlistData);
            return response.data;
        } catch (error) {
            console.error('Error creating wishlist:', error);
            throw error;
        }
    },

    // Update wishlist
    async updateWishlist(id, updates) {
        try {
            const response = await api.patch(`/wishlists/${id}/`, updates);
            return response.data;
        } catch (error) {
            console.error('Error updating wishlist:', error);
            throw error;
        }
    },

    // Delete wishlist
    async deleteWishlist(id) {
        try {
            await api.delete(`/wishlists/${id}/`);
            return { success: true };
        } catch (error) {
            console.error('Error deleting wishlist:', error);
            throw error;
        }
    },

    // Add product to wishlist
    async addProductToWishlist(wishlistId, productId) {
        try {
            const response = await api.post(`/wishlists/${wishlistId}/add_product/`, {
                product_id: productId
            });
            return response.data;
        } catch (error) {
            console.error('Error adding product to wishlist:', error);
            throw error;
        }
    },

    // Remove product from wishlist
    async removeProductFromWishlist(wishlistId, productId) {
        try {
            await api.delete(`/wishlists/${wishlistId}/remove_product/`, {
                data: { product_id: productId }
            });
            return { success: true };
        } catch (error) {
            console.error('Error removing product from wishlist:', error);
            throw error;
        }
    },

    // Get wishlist products
    async getWishlistProducts(wishlistId, params = {}) {
        try {
            const response = await api.get(`/wishlists/${wishlistId}/products/`, { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching wishlist products:', error);
            throw error;
        }
    },

    // Share wishlist
    async shareWishlist(wishlistId, shareData) {
        try {
            const response = await api.post(`/wishlists/${wishlistId}/share/`, shareData);
            return response.data;
        } catch (error) {
            console.error('Error sharing wishlist:', error);
            throw error;
        }
    },

    // Get public wishlists
    async getPublicWishlists(params = {}) {
        try {
            const response = await api.get('/wishlists/public/', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching public wishlists:', error);
            throw error;
        }
    }
};

export default wishlistsService; 